export enum PlanClass {
  Domestic = 1,
  MostPopular = 2,
}
